export type ActivityEventInput = {
  event_name: "page.viewed" | "feature.viewed" | "feature.used"
  category: "navigation" | "dashboard" | "feature"
  page?: string
  route?: string
  metadata?: Record<string, string | number | boolean | null>
}

const SESSION_KEY = "signals.activitySessionId"

function activitySessionId(): string | null {
  if (typeof window === "undefined") return null
  let id = window.sessionStorage.getItem(SESSION_KEY)
  if (!id) {
    id = window.crypto.randomUUID()
    window.sessionStorage.setItem(SESSION_KEY, id)
  }
  return id
}

export function trackActivity(event: ActivityEventInput): void {
  const sessionId = activitySessionId()
  void fetch("/api/activity-events", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(sessionId ? { "X-Signals-Session-Id": sessionId } : {}),
    },
    body: JSON.stringify(event),
    keepalive: true,
  }).catch(() => undefined)
}
